import React from 'react';
import { Row } from 'reactstrap';

const ErrorJobsStats = ({ content }) => (
  <Row className="centerAlignContent">{content.SOMETHING_WENT_WRONG}</Row>
);

export default ErrorJobsStats;
